import { Component, Vue, Watch } from 'vue-property-decorator';
import { DateTime } from "luxon";

import Doughnut from '@/components/charts/Doughnut';

interface ServerVotes {
  [key: string]: {
    value: number;
    selected?: boolean;
  };
}
interface ServerComment {
  userId: string;
  own: boolean;
  vote: string;
  value: string;
  createdAt: number;
  updatedAt: number;
}

@Component({
    components: {
        Doughnut
    },
    filters: {
      time: (input: string) => {
        return DateTime.fromSQL(input).toRelative();
      }
    }
})
export default class VoteView extends Vue {
    pollId = 'lekeland';
    showSignIn = false;
    phoneNumber = {
      buffer: localStorage.getItem('sprett.booking.confirmationCode.forNumber') || '',
      loading: false,
      error: '',
      success: '',
      valid: true,
    }
    email = {
      buffer: '',
      loading: false,
      error: '',
      success: '',
      valid: true,
    }
    subscribe = {
      buffer: false,
      loading: false,
      error: '',
      success: '',
      valid: true,
    }
    voting = {
      buffer: '',
      loading: false,
      error: '',
      success: '',
    }
    comment: {
      buffer: null | string;
      storedValue: null | string;
      loading: boolean;
      error: string;
      success: string;
    } = {
      buffer: null,
      storedValue: null,
      loading: false,
      error: '',
      success: '',
    }
    mounted(){
      this.getCurrentUser();
    }
    resetPhoneNumber(){
      this.confirmationCode.forNumber = '';
      this.confirmationCode.length = 0;
      this.phoneNumber.buffer = '';
      this.$nextTick(() => {
          (this.$refs.phoneNumberField as HTMLInputElement).focus();
      })
    }
    @Watch('phoneNumber.buffer')
    onBufferPhoneNumberChange(){
      this.phoneNumber.success = '';
      this.phoneNumber.error = '';
    }
    user: User | null = null;
    @Watch('user')
    onUserChange(){
      this.voting.success = '';
      for (const choice of this.choices){
        choice.selected = false;
      }
      if (this.user){
        const votingFor = this.voting.buffer;
        if (votingFor){
          this.voteFor(votingFor);
        }
        this.showSignIn = false;
        this.subscribe.buffer = this.user.subscribeToEmail;
      }
      this.getVotes();
      this.getComments();
    }
    confirmationCode = {
      sent: false,
      loading: false,
      error: '',
      success: '',
      value: '',
      forNumber: localStorage.getItem('sprett.booking.confirmationCode.forNumber') || '',
      length: Number(localStorage.getItem('sprett.booking.confirmationCode.length')),
      clear: function(){
        this.length = 0;
        this.forNumber = '';
        // localStorage.removeItem('sprett.booking.confirmationCode.length');
        // localStorage.removeItem('sprett.booking.confirmationCode.forNumber');
      }
    }
    choices: Choice[] = [
        {
            title: 'Trampoliner',
            key: 'trampolines',
            // description: "Please don't take away my Lekeland!",
            color: this.$vuetify.theme.currentTheme.primary as string,
            value: 0,
            selected: false,
        },
        {
            title: 'Klatring + Rope Course',
            key: 'climbing',
            // description: "Tårn og bruer og greier.",
            color: this.$vuetify.theme.currentTheme.error as string,
            value: 0,
            selected: false,
        },
        {
            title: 'Rope Course',
            key: 'ropecourse',
            // description: "Gi meg et sted jeg kan slappe av.",
            color: this.$vuetify.theme.currentTheme.success as string,
            value: 0,
            selected: false,
        },
        {
            title: 'Behold Lekeland',
            key: 'keep',
            // description: "Hørt om Willy Wonka?",
            color: this.$vuetify.theme.currentTheme.warning as string,
            value: 0,
            selected: false,
        },
    ]
    choiceColor(key: string){
      const choice = this.choices.find(choice => choice.key === key);
      if (choice){
        return choice.color;
      }
      return undefined;
    }
    selection = '';
    get showGraph(){
      let hasValues = false;
      for (const choice of this.choices){
        if (choice.value) {
          if (hasValues){
            return true;
          }
          hasValues = true;
        }
      }
      return false;
    }
    voteFor(voteChoice: Choice|string){
      if (typeof(voteChoice) === 'string'){
        voteChoice = this.choices.find(choice => choice.key === voteChoice)!;
        if (!voteChoice){
          return;
        }
      }
      this.voting.buffer = voteChoice.key;
      if (!this.user){
          this.showSignIn = true;
          return;
      }
      this.submitVote(voteChoice);
    }
    get graph(){
      return this.$refs.graph as Vue;
    }
    submitVote(choice: Choice){
      this.voting.loading = true;
      const body = new URLSearchParams();
      body.append('action', 'sprett_poll_vote');
      body.append('poll_id', this.pollId);
      body.append('value', choice.key);
      fetch(this.$ajax.url+'', {
        method: 'post',
        body,
      }).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then(votes => {
        const voteWasChanged = this.updateVotes(votes);
        this.$nextTick(()=>{
        if (this.graph && this.graph.$el.getBoundingClientRect().top < 0){
          this.graph.$el.scrollIntoView({
             behavior: 'smooth',
          });
        }
        })
        this.voting.success = voteWasChanged ? 'Din stemme ble endret.' : 'Din stemme er registrert.'
      })
      .catch(error=>{
        // this.buffer.phoneNumber = (this.user && this.user.phoneNumber) || '';
        this.voting.error = 'Din stemme kunne ikke registreres.'
        console.error(error);
      }).finally(()=>{
        this.voting.loading = false;
      })
    }
    submitComment(){
      this.comment.loading = true;
      const body = new URLSearchParams();
      body.append('action', 'sprett_poll_comment');
      body.append('poll_id', this.pollId);
      body.append('value', this.comment.buffer || '');
      fetch(this.$ajax.url+'', {
        method: 'post',
        body,
      }).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then(comments => {
        const wasEmpty = !this.comment.storedValue;
        this.updateComments(comments);
        // this.$nextTick(()=>{
        // if (this.graph && this.graph.$el.getBoundingClientRect().top < 0){
        //   this.graph.$el.scrollIntoView({
        //      behavior: 'smooth',
        //   });
        // }
        // })
        this.comment.success = wasEmpty ? 'Din kommentar ble oppdatert.' : 'Din kommentar er registrert.'
      })
      .catch(error=>{
        // this.buffer.phoneNumber = (this.user && this.user.phoneNumber) || '';
        this.comment.error = 'Det oppstod en feil ved registrering av kommentar.'
        console.error(error);
      }).finally(()=>{
        this.comment.loading = false;
      })
    }
    submitSubscribe(){
      if (!this.user){
        return;
      }
      const subscribeToEmail = !!this.email.buffer || this.subscribe.buffer;
      this.subscribe.loading = true;
      const body = new URLSearchParams();
      body.append('action', 'sprett_subscribe');
      body.append('emailAddress', this.email.buffer || '');
      body.append('subscribeToEmail', subscribeToEmail.toString());
      fetch(this.$ajax.url+'', {
        method: 'post',
        body,
      }).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then((user: User) => {
        this.subscribe.success = user.subscribeToEmail ? 'Du ble meldt på vårt nyhetsbrev.' : 'Du ble meldt av vårt nyhetsbrev.'
        if (this.user){
          Object.assign(this.user, user);
        }
        this.subscribe.buffer = user.subscribeToEmail;
        this.email.buffer = '';
      })
      .catch(error=>{
        // this.buffer.phoneNumber = (this.user && this.user.phoneNumber) || '';
        if (this.user){
          this.subscribe.buffer = this.user.subscribeToEmail;
        }
        this.subscribe.error = subscribeToEmail ?  'Det oppstod en feil ved registrering.' : 'Det oppsotd en feil ved utmelding.'
        console.error(error);
      }).finally(()=>{
        this.subscribe.loading = false;
      })
    }
    getVotes(){
      fetch(this.$ajax.url+`?action=sprett_poll_votes&poll_id=${this.pollId}`).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then(votes => this.updateVotes(votes))
      .catch(error=>{
        console.error(error);
      });
    }
    getComments(){
      fetch(this.$ajax.url+`?action=sprett_poll_comments&poll_id=${this.pollId}`).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then(comments => this.updateComments(comments))
      .catch(error=>{
        console.error(error);
      });
    }
    comments: ServerComment[] = [];
    updateComments(comments: ServerComment[]){
      for (const comment of comments){
        if (comment.own){
          this.comment.buffer = comment.value;
          this.comment.storedValue = comment.value;
        }
      }
      this.comments = comments;
    }
    updateVotes(votes: ServerVotes): boolean{
      let voteWasChanged = false;
      for (const choice of this.choices){
        if (choice.selected){
          console.log(choice);
          if (!votes[choice.key] || !votes[choice.key].selected){
            voteWasChanged = true;
          }
        }
        if (votes[choice.key]){
          choice.value = votes[choice.key].value;
          if (votes[choice.key].selected){
            this.selection = choice.key;
          }
          choice.selected = votes[choice.key].selected || false;
        } else {
          choice.value = 0;
          choice.selected = false;
        }
        // choice.value += 1
      }
      return voteWasChanged;
    }
    signInBySMS(){
      if (this.phoneNumber.buffer == (this.user && this.user.phoneNumber)){
        return;
      }
      this.phoneNumber.loading = true;
      const body = new URLSearchParams();
      body.append('action', 'sprett_booking_sign_in_by_sms');
      body.append('phoneNumber', this.phoneNumber.buffer);
      fetch(this.$ajax.url+'', {
        method: 'post',
        body,
      }).then(response=>{
        if (response.status >= 400){
          return response.text().then(message=>{
            throw Error(response.status+' '+message);
          })
        }
        return response.json();
      }).then(({codeLength, confirmationCodeSentTo}: {codeLength: number; confirmationCodeSentTo: string})=>{
        this.phoneNumber.error = '';
        // this.successes.phoneNumber = 'Bekreftelseskode er sendt på SMS'
        this.confirmationCode.length = codeLength;
        this.confirmationCode.forNumber = confirmationCodeSentTo;
        this.$nextTick(()=>{
          (this.$refs.confirmationCodeField as HTMLInputElement).focus();
        });
      })
      .catch(error=>{
        // this.buffer.phoneNumber = (this.user && this.user.phoneNumber) || '';
        this.phoneNumber.error = 'Det oppstod en feil ved sending av bekreftelseskode.'
        console.error(error);
      }).finally(()=>{
        this.phoneNumber.loading = false;
        // 94190279
      })
    }

  @Watch('confirmationCode.forNumber')
  onConfirmationCodeForNumberChange(){
    localStorage.setItem('sprett.booking.confirmationCode.forNumber', this.confirmationCode.forNumber);
  }
  @Watch('confirmationCode.length')
  onConfirmationCodeLengthChange(){
    localStorage.setItem('sprett.booking.confirmationCode.length', this.confirmationCode.length.toString());
  }
  @Watch('confirmationCode.value')
  onConfirmationCodeValueChange(){
    if (this.confirmationCode.value.length === this.confirmationCode.length){
      if (this.user){
        this.submitConfirmationCode();
      } else {
        this.submitSignInConfirmation();
      }
    }
  }
  submitSignInConfirmation(){
    if (!this.confirmationCode.value){
      return;
    }
    this.confirmationCode.loading = true;
    const body = JSON.stringify({
      phoneNumber: this.confirmationCode.forNumber,
      code: this.confirmationCode.value,
    })
    fetch(this.$ajax.url+'?action=sprett_booking_confirm_sign_in_by_sms', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
      credentials: 'same-origin',
      // mode: 'no-cors',
    }).then(response=>{
      if (response.status >= 400){
        return response.text().then(message=>{
          throw Error(response.status+' '+message);
        })
      }
      return response.json();
    }).then((user: User)=>{
      this.user = user;
      this.confirmationCode.success = 'Koden ble godkjent'
      this.confirmationCode.clear();
      this.phoneNumber.buffer = '';
      this.confirmationCode.value = '';
    })
    .catch(error=>{
      this.confirmationCode.error = 'Ugyldig kode'
      console.error(error);
    }).finally(()=>{
      this.confirmationCode.loading = false;
    })
  }
  submitConfirmationCode(){
    if (!this.confirmationCode.value){
      return;
    }
    this.confirmationCode.loading = true;
    const body = JSON.stringify({
      phoneNumber: this.phoneNumber.buffer,
      code: this.confirmationCode.value,
    })
    fetch(this.$ajax.url+'?action=sprett_booking_confirm_update_phone_number', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
      // mode: 'no-cors',
    }).then(response=>{
      if (response.status >= 400){
        return response.text().then(message=>{
          throw Error(response.status+' '+message);
        })
      }
      return response.json();
    }).then(({phoneNumber})=>{
      if (this.user){
        this.user.phoneNumber = phoneNumber;
      }
      this.confirmationCode.clear();
      this.phoneNumber.success = 'Nummeret ble oppdatert.'
    })
    .catch(error=>{
      this.confirmationCode.error = 'Det oppstod en feil ved bekreftelse av telefonnummer.'
      console.error(error);
    }).finally(()=>{
      this.confirmationCode.loading = false;
    })
  }
  signOut(){
    fetch(this.$ajax.url+'?action=sprett_booking_sign_out', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'same-origin',
      // mode: 'no-cors',
    }).then(response=>{
      if (response.status >= 400){
        return response.text().then(message=>{
          throw Error(response.status+' '+message);
        })
      }
      return response.json();
    }).then(()=>{
      this.user = null;
    })
    .catch(error=>{
      console.log(error);
      console.error(error);
    }).finally(()=>{
      //
    })
  }
  getCurrentUser(){
    fetch(this.$ajax.url+'?action=sprett_booking_auth_current_user').then(response=>{
      if (response.status === 401){
        throw Error('Not signed in');
      }
      else if (response.status >= 400){
        return response.text().then(message=>{
          throw Error(response.status+' '+message);
        })
      }
      return response.json();
    }).then((user: User)=>{
      const defaultUser: User = {
        login: '',
        displayName: '',
        yearOfBirth: '',
        phoneNumber: '',
        hasValidDeclaration: false,
        declarations: [],
        email: '',
        subscribeToEmail: false,
        county: '',
      }
      user = Object.assign(defaultUser, user);
      user.declarations.forEach(declaration => {
        declaration.removing = false;
      })
      this.user = user;
    }).catch(()=>{
      //
    });
  }
}